import { connect } from 'react-redux'
import { compose } from 'redux'
import { printSetActiveTab } from '../../../actions'
import FormFlyerDataTab from '../present/FormFlyerDataTab'
import { FLYER_DATA } from '../../../constants/state'
import getData from '../../../functions/getData'
import toJS from '../../../hoc/toJS'

const mapStateToProps = state => ({
    activeTab: state.getIn(['ui', 'print', 'activeTab']),
    flyerServerData: getData(state, FLYER_DATA)
    
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    setActiveTab: (activeClass, id) => {
        if(activeClass !== "accordion-item-open") {
            dispatch(printSetActiveTab(id))
        }
    }
})

const FormFlyerDataTabContainer = ({
    tabs, 
    activeWeek, 
    side, 
    cinemaId, 
    printType, 
    printFormat, 
    landscape, 
    printPk,
    values, 
    setActiveTab, 
    activeTab, 
    flyerServerData, 
    basicUrl
}) => {
    return (
        <FormFlyerDataTab 
            tabs={tabs}
            activeWeek={activeWeek}
            side={side}
            cinemaId={cinemaId}
            printType={printType}
            printFormat={printFormat}
            landscape={landscape}
            printPk={printPk}
            values={values}
            setActiveTab={setActiveTab}
            activeTab={activeTab}
            flyerServerData={flyerServerData}
            basicUrl={basicUrl}
        />
    )
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    toJS()
)(FormFlyerDataTabContainer)